import CalculateMonthlyPay from "./CalculateMonthlyPay";

interface payRecords {
    is_Duplicate: number;
    Pay_frequency: any;
    Gross_Pay: number | string | null;
}
const CalculateMonthlyGrossPay = (payRecords:payRecords[]) => {
    if (!Array.isArray(payRecords)) {
        return 0;
    }
    const mappedGrossPayRecords= payRecords.map(file=>({...file,Pay:file.Gross_Pay}))
    return CalculateMonthlyPay(mappedGrossPayRecords);
}

export default CalculateMonthlyGrossPay;